import { render } from "./Rankinglist.vue?vue&type=template&id=44fad44d&ts=true"
import script from "./Rankinglist.vue?vue&type=script&lang=ts"
export * from "./Rankinglist.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__